import { render, staticRenderFns } from "./OCrossTable.vue?vue&type=template&id=ef8c7808&scoped=true&"
import script from "./OCrossTable.vue?vue&type=script&lang=js&"
export * from "./OCrossTable.vue?vue&type=script&lang=js&"
import style0 from "./OCrossTable.vue?vue&type=style&index=0&id=ef8c7808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8c7808",
  null
  
)

export default component.exports